"use client"

import { CHATBOT_SUGGESTIONS } from "@/lib/chatbot/constants"

interface ChatbotSuggestionsProps {
  onSelect: (message: string) => void
  disabled?: boolean
}

export default function ChatbotSuggestions({ onSelect, disabled }: ChatbotSuggestionsProps) {
  return (
    <div className="flex flex-wrap gap-1.5 px-3 pb-2">
      {CHATBOT_SUGGESTIONS.map((suggestion) => (
        <button
          key={suggestion.label}
          onClick={() => !disabled && onSelect(suggestion.message)}
          disabled={disabled}
          className="rounded-full border border-border bg-background px-3 py-1.5 text-xs font-medium text-foreground transition-colors hover:bg-accent hover:text-accent-foreground disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {suggestion.label}
        </button>
      ))}
    </div>
  )
}
